import { render, staticRenderFns } from "./MainAdmin.vue?vue&type=template&id=4f9b79ce&scoped=true"
import script from "./MainAdmin.vue?vue&type=script&lang=js"
export * from "./MainAdmin.vue?vue&type=script&lang=js"
import style0 from "./MainAdmin.vue?vue&type=style&index=0&id=4f9b79ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9b79ce",
  null
  
)

export default component.exports